(() => {
  const config = document.getElementById('unity-size-guide-labels');
  if (!config) return;
  let labels;
  try { labels = JSON.parse(config.textContent); } catch { return; }
  const aliases = new Map();
  const groups = {
    chest: ['CHEST', 'TORACE', 'PECHO', 'POITRINE', 'BRUST'],
    waist: ['WAIST', 'VITA', 'CINTURA', 'TAILLE'],
    hem: ['BOTTOM HEM', 'BOTTOM', 'HEM', 'FONDO', 'BAJO', 'BAS', 'SAUM'],
    length: ['LENGTH', 'LUNGHEZZA', 'LARGO', 'LONGUEUR', 'LÄNGE'],
    sleeve: ['SLEEVE', 'SLEEVE LENGTH', 'MANICA', 'MANGA', 'MANCHE', 'ÄRMEL'],
    shoulder: ['SHOULDER', 'SHOULDERS', 'SHOULDER WIDTH', 'SPALLE', 'HOMBROS', 'ÉPAULES', 'SCHULTERN'],
    raglan: ['SLEEVE FROM CENTRE BACK', 'SLEEVE FROM CENTER BACK', 'MANICA DAL CENTRO DIETRO', 'MANGA DESDE EL CENTRO DE LA ESPALDA', 'MANCHE DEPUIS LE MILIEU DU DOS', 'ÄRMEL AB HINTERER MITTE']
  };
  Object.entries(groups).forEach(([key, values]) => values.forEach(value => aliases.set(value, key)));
  const order = ['chest', 'waist', 'hem', 'length', 'sleeve', 'raglan', 'shoulder'];
  const text = (el, value) => { if (el && value && el.textContent !== value) el.textContent = value; };
  function footerNote(footer) {
    if (footer.dataset.unityNote === labels.note) return;
    footer.replaceChildren();
    const note = document.createElement('div');
    note.textContent = labels.note;
    const half = document.createElement('div');
    half.className = 'unity-size-guide-half';
    half.textContent = labels.half;
    footer.append(note, half);
    footer.dataset.unityNote = labels.note;
  }
  function update() {
    document.querySelectorAll('.ks-chart-modal-link ._ks_text').forEach(el => {
      text(el, labels.link);
      el.removeAttribute('aria-label');
    });
    document.querySelectorAll('.kiwi-sizing-modal').forEach(modal => {
      const close = modal.querySelector('.ks-modal-close');
      if (close && close.getAttribute('aria-label') !== labels.close) close.setAttribute('aria-label', labels.close);
      modal.querySelectorAll('.ks-html-content').forEach(block => {
        const source = block.dataset.unitySource || block.textContent.trim();
        if (/^(Guida alle taglie|Size guide|Size chart|Guía de tallas|Guide des tailles|Größentabelle)$/i.test(source)) {
          block.dataset.unitySource = source;
          block.classList.add('unity-size-guide-title');
          if (block.children.length) block.textContent = labels.title;
          else text(block, labels.title);
        } else if (/^Measurements in cm\s*[·•-]\s*Garment laid flat/i.test(source)) {
          block.dataset.unitySource = source;
          block.classList.add('unity-size-guide-footer');
          footerNote(block);
        }
      });
      modal.querySelectorAll('.ks-table-content-wrapper').forEach(wrapper => {
        const table = wrapper.querySelector('.ks-table');
        if (!table) return;
        const rows = Array.from(table.rows).filter(row => row.querySelector('th[scope="row"]'));
        const keys = rows.map(row => {
          const cell = row.querySelector('th[scope="row"]');
          const key = cell.dataset.unityMeasure || aliases.get(cell.textContent.trim().toUpperCase());
          if (key) { cell.dataset.unityMeasure = key; text(cell, labels[key]); }
          return key;
        });
        if (!rows.length || keys.some(key => !key)) return;
        const sorted = rows.slice().sort((a, b) => order.indexOf(a.querySelector('th').dataset.unityMeasure) - order.indexOf(b.querySelector('th').dataset.unityMeasure));
        if (sorted.some((row, i) => row !== rows[i])) sorted.forEach(row => row.parentElement.appendChild(row));
        text(wrapper.querySelector('.ks-table-header'), labels.title);
        const footer = wrapper.querySelector('.ks-table-footer');
        if (footer) footerNote(footer);
      });
    });
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  const relevant = '.kiwi-sizing-modal,.ks-chart-modal-link';
  const observer = new MutationObserver(records => {
    if (records.some(record => record.target.nodeType === 1 && (record.target.closest(relevant) || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant)))))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  update();
})();
